import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function getBreakpointsClassNames(_ref) {
  var breakpoints = _ref.breakpoints,
    mappers = _ref.mappers;
  return Object.entries(breakpoints).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      breakpoint = _ref3[0],
      props = _ref3[1];
    for (var _i = 0, _Object$entries = Object.entries(mappers); _i < _Object$entries.length; _i++) {
      var data = _Object$entries[_i];
      var _data = _slicedToArray(data, 2),
        propName = _data[0],
        mapper = _data[1];
      var value = props[propName];
      if (value) {
        if (!acc[propName]) {
          acc[propName] = [];
        }
        var classNames = mapper(value);
        if (classNames) {
          var _acc$propName;
          (_acc$propName = acc[propName]).push.apply(_acc$propName, _toConsumableArray(classNames.map(function (className) {
            return className + "-breakpoint-".concat(breakpoint);
          })));
        }
      }
    }
    return acc;
  }, {});
}